export default __webpack_public_path__ + "static/media/IU_Home4.45207d74.jpg";